<template>
<Layout>
  <div class="section content is-size-7">
    <p>
       ติดต่อ: สายด่วน: XXXXXXXX อีเมล: cuca@778mobile.com 
    </p>
  </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Help',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/TH/Help.vue